import buildUrlWithParams from 'utils/global/buildUrlWithParams'
import regEx from 'utils/global/regEx'
import { DEFAULT_LOCALE_CODE } from '@messenger/consts'

const ensureUrlProtocol = (url: string): string =>
  regEx.urlScheme.test(url) ? url : `https://${url}`

/**
 * The language an M3 tab hands back to the case's site: the one the tab was
 * opened in, then the one the browser remembers, then i18n's.
 */
export const returnToOrderLanguage = (i18nLanguage?: string): string => {
  if (typeof window === 'undefined') return i18nLanguage || DEFAULT_LOCALE_CODE
  let stored: string | null = null
  try {
    stored = window.localStorage.getItem('language')
  } catch {
    // Storage unavailable — the query parameter and i18n still answer.
  }
  return (
    new URLSearchParams(window.location.search).get('lang') ||
    stored ||
    i18nLanguage ||
    DEFAULT_LOCALE_CODE
  )
}

/**
 * The case's return URL with the tab's language on it, or null when the case
 * has none. A caller with no URL closes the tab instead.
 */
export const returnToOrderUrl = (
  returnUrl: string | null | undefined,
  i18nLanguage?: string,
): string | null => {
  if (!returnUrl) return null
  const lang = returnToOrderLanguage(i18nLanguage)
  try {
    const url = new URL(ensureUrlProtocol(returnUrl))
    url.searchParams.set('lang', lang)
    return url.toString()
  } catch {
    return buildUrlWithParams(
      ensureUrlProtocol(returnUrl),
      new URLSearchParams({ lang }),
    )
  }
}

/** Leave for the case's site, or close the tab when the case has no URL. */
export const leaveForReturnUrl = (
  returnUrl: string | null | undefined,
  i18nLanguage?: string,
): void => {
  const url = returnToOrderUrl(returnUrl, i18nLanguage)
  if (url) {
    window.location.href = url
  } else {
    window.close()
  }
}
